import { RIPPLING } from '@/integrations/modules/rippling/consts';
import { getRipplingWorkers } from '@/integrations/modules/rippling/selectors/getEmployees';
import type { RipplingUsersData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';
import type { WiwState } from '@/store';

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Map } from 'immutable';

export interface SaveRipplingUsersPayload {
  ignored: Map<number, string | null>;
  matched: Map<number, string>;
}

export interface SaveRipplingUsersResponse {
  data: {
    job_id?: string;
  };
}

export const saveRipplingUsers = createAsyncThunk(
  'rippling/saveUsers',
  async (payload: SaveRipplingUsersPayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await Integrations.url(`/${RIPPLING}/v2/config/users`).post(payload);
      await dispatch(optimisticallyUpdateRipplingUsers(payload));
      return response as SaveRipplingUsersResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const optimisticallyUpdateRipplingUsers = createAsyncThunk(
  'rippling/optimisticallyUpdateUsers',
  async (payload: SaveRipplingUsersPayload, { getState }) => {
    const state = getState() as WiwState;
    const ripplingWorkers = getRipplingWorkers(state);

    return {
      matched: payload.matched,
      ignored: payload.ignored,
      rippling: ripplingWorkers,
    } as RipplingUsersData;
  },
);
